import type { ReactNode } from "react";

/**
 * The app's one small-caps label.
 *
 * It was written three times with two different letter-spacings: the settings section heading, the
 * pod detail card headings, and the event form's field labels. 0.06em is the one the two heading
 * uses already agreed on.
 */
export const SECTION_LABEL_CLASS =
  "text-xs font-semibold uppercase tracking-[0.06em] text-text-muted";

interface SectionLabelProps {
  children: ReactNode;
  /** Put the label on its own line, for a label stacked above the value it names. */
  block?: boolean;
}

/** The label on its own, where there is no heading or form control to carry the class. */
export function SectionLabel({ children, block = false }: SectionLabelProps) {
  return (
    <span className={`${block ? "block" : ""} ${SECTION_LABEL_CLASS}`}>{children}</span>
  );
}
